/**
 * Los KPIs del programa, para su sección del panel.
 *
 * Va por la MISMA ruta del catálogo que usa el agente (§6). Definir o
 * renombrar un KPI son comandos y se hacen hablando con él; aquí solo se
 * miran, que es para lo que existe esta sección: saber qué se está midiendo
 * antes de escribir la mecánica que lo usa.
 */
import { queryOptions } from "@tanstack/react-query";

import { request } from "../lib/api-client.ts";
import { API_BASE } from "../lib/api-routes.ts";
import type { operations } from "../lib/api-types.ts";

type ListResponse =
  operations["list_kpis"]["responses"][200]["content"]["application/json"]["data"];

export type KpiSummary = ListResponse["kpis"][number];

export const listKpis = (): Promise<ListResponse> =>
  request<ListResponse>(`${API_BASE}/queries/list_kpis`);

export const kpisQuery = () =>
  queryOptions({
    queryKey: ["kpis"] as const,
    queryFn: listKpis,
  });
